import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../auth/authConfig";

const Login = () => {
    const { instance } = useMsal();
    
    const handleLoginRedirect = async () => {
        try {
            await instance.loginRedirect(loginRequest);
        } catch (error) {
            console.error("Login redirect error:", error);
        }
    };
    
    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 flex items-center justify-center p-6">
            <div className="max-w-md w-full">
                <div className="bg-white/95 backdrop-blur-xl rounded-2xl shadow-2xl p-8 border border-gray-200">
                    <div className="text-center mb-8">
                        <img 
                            src="https://ku-bu.de/wp-content/uploads/2022/06/KuBu_neu_1200.png" 
                            alt="Ku-Bu Logo" 
                            className="h-24 mx-auto mb-6"
                        />
                        <h1 className="text-3xl font-bold text-gray-900 mb-2">
                            Veranstaltungsmeldungen
                        </h1>
                        <p className="text-gray-600">
                            KUltur im BUnker
                        </p>
                    </div>
                    
                    <div className="space-y-4">
                        <button 
                            data-testid="login-button"
                            onClick={handleLoginRedirect}
                            className="w-full bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white font-semibold py-4 px-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5 flex items-center justify-center gap-3"
                        >
                            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M12 2L2 7v10c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-10-5z"/>
                            </svg>
                            Mit Microsoft anmelden
                        </button>
                        
                        <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
                            <p className="text-sm text-blue-800 text-center">
                                <strong>Hinweis:</strong> Nur Konten mit <strong>@ku-bu.de</strong> E-Mail-Adressen haben Zugriff.
                            </p>
                        </div>
                    </div>
                </div>
                
                <p className="text-center text-gray-400 text-sm mt-6">
                    Ein Projekt des Kultdiak Stuttgart e.V.
                </p>
            </div>
        </div>
    );
};

export default Login;